import { render, staticRenderFns } from "./BaseTBodyTH.vue?vue&type=template&id=8f44308e&"
import script from "./BaseTBodyTH.vue?vue&type=script&lang=js&"
export * from "./BaseTBodyTH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports